import * as Yup from 'yup'

const buyerSchema = {}

buyerSchema.validateBuyerAdd = () => {
  return Yup.object({
    buyer_name: Yup.string()
      .required('Supplier name is required.')
      .min(3, 'Supplier name minimum length is 3')
      .max(45, 'Supplier name should be at most 45 characters.'),
      // .matches(/^[aA-z0-9Z-\s]+$/, `Supplier name should be Alphanumeric only`),
    buyer_address: Yup.string(),
    // buyer_state_id: Yup.string().required('State is required.'),
    // buyer_city_id: Yup.string().required('City is required.'),
    // buyer_pincode: Yup.string()
    //   .required('Pincode is required.')
    //   .max(9, 'Pincode symbol should be at most 9 characters.')
    //   .min(5,'Pincode symbol should be minimum 5 characters.')
    //   .matches(/^[0-9-\s\@\$\#\&\_\.\(\)\[\]\,\:\'\-]+$/, `Pincode should be Number`),
  })
}

buyerSchema.validateBuyerEdit = () => {
  return Yup.object({
    buyer_name: Yup.string()
      .required('Supplier name is required.')
      .min(3, 'Supplier name minimum length is 3')
      .max(45, 'Supplier name should be at most 45 characters.'),
      // .matches(/^[aA-z0-9Z-\s]+$/, `Supplier name should be Alphanumeric only`),
    // buyer_address: Yup.string(),
    // buyer_state_id: Yup.string().required('State is required.').nullable(),
    // buyer_city_id: Yup.string().required('City is required.').nullable(),
    // buyer_pincode: Yup.string()
    //   .required('Pincode is required.')
    //   .max(9, 'Pincode symbol should be at most 6 characters.')
    //   .min(5,'Pincode symbol should be at most 5 characters.')
    //   .matches(/^[0-9-\s\@\$\#\&\_\.\(\)\[\]\,\:\'\-]+$/, `Pincode should be Number`).nullable(),
  })
}

export default buyerSchema
